import { DefaultPalette } from '@uifabric/styling/lib/index';
import { ThemeProvider } from '@fluentui/react-theme-provider';
import { observer } from 'mobx-react-lite';
import { Toggle } from '@fluentui/react/lib/Toggle';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { onIsOnlineMeetingChanged } from 'owa-calendar-compose-form-actions';
import isOnlineMeeting from 'owa-calendar-compose-form-store/lib/selectors/isOnlineMeeting';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getToggleButtonTheme } from 'owa-component-styling-utils';
import loc from 'owa-localize';
import { getOnlineProviderLabel } from 'owa-online-meeting';
import { OnlineMeetingProviderType } from 'owa-online-meeting/lib/utils/OnlineMeetingProviderType';
import * as React from 'react';
import {
    onlineTeamsMeetingLocationTooltipText,
    onlineMeetingsTooltipText,
} from './OnlineMeetingDropdownToggle.locstring.json';

let styles = require('./OnlineMeetingToggle.scss');

export interface OnlineMeetingToggleProps {
    isOnlineMeeting: boolean;
    provider: OnlineMeetingProviderType;
    colorScheme: ColorScheme;
    canChangeToggle: boolean;
    compactMode: Boolean;
    isDarkMode?: boolean;
    disabled?: boolean;
    shouldShowTooltip?: boolean;
}

export default observer(function OnlineMeetingToggle(props: OnlineMeetingToggleProps) {
    const onToggleProvider = (isChecked: boolean) => {
        if (props.canChangeToggle) {
            setIsToggleChecked(isChecked);
            onIsOnlineMeetingChanged(
                isChecked,
                props.provider,
                true /* isOnlineMeetingExplicitlySet */
            );
        }
    };
    const [isToggleChecked, setIsToggleChecked] = React.useState(props.isOnlineMeeting);
    const onlineProviderLabel = getOnlineProviderLabel(props.provider);
    const toggleTheme = getToggleButtonTheme(props.colorScheme, props.isDarkMode);
    const isOnlineMeetingToggleChecked = isToggleChecked || isOnlineMeeting();
    const tooltipText = !props.canChangeToggle
        ? loc(onlineTeamsMeetingLocationTooltipText)
        : props.shouldShowTooltip && !isOnlineMeetingToggleChecked
        ? loc(onlineMeetingsTooltipText)
        : '';
    return (
        <div className={props.compactMode ? styles.compactToggleButton : styles.toggleButton}>
            <TooltipHost content={tooltipText}>
                <ThemeProvider theme={toggleTheme}>
                    <Toggle
                        defaultChecked={false}
                        ariaLabel={onlineProviderLabel}
                        onChanged={onToggleProvider}
                        checked={isOnlineMeetingToggleChecked}
                        className={styles.toggle}
                        label={onlineProviderLabel}
                        inlineLabel={true}
                        // to take the space so that label appears before toggle
                        // refer to https://developer.microsoft.com/en-us/fabric#/components/toggle for inlineLabel description
                        onText={' '}
                        offText={' '}
                        disabled={props.disabled}
                        styles={{
                            pill: {
                                selectors: {
                                    '.ms-Fabric--isFocusVisible &:focus:after': {
                                        outline: `1px solid ${DefaultPalette.neutralSecondary} !important`,
                                    },
                                },
                            },
                        }}
                    />
                </ThemeProvider>
            </TooltipHost>
        </div>
    );
});
